import { DataMappingProps } from 'enums/CreateProductStageNavigationBarEnums';
import { FarmBoxCommodityDestribution } from 'models/FarmBoxCommodityDestribution/farmBoxCommodityDestribution.model';
import { FieldDetails } from 'models/Farmbox/field.model';
import { FuelAndEnergyDetails } from 'models/Farmbox/fuelAndEnergy.model';
import { TransportationDetails } from 'models/Farmbox/transportation.model';
import { FarmboxRawMaterialsData } from 'models/FarmboxRawMaterials/farmBoxRawMaterials.model';
import { useLocation } from 'react-router-dom';
import { isActiveTab } from '../DataMapDrawer/DataMapDrawerHelper';

export type FormDataTypes =
  | FarmboxRawMaterialsData
  | TransportationDetails
  | FuelAndEnergyDetails
  | FieldDetails
  | FarmBoxCommodityDestribution;

export const useActiveTabChecks = (
  location: ReturnType<typeof useLocation>
) => ({
  isRawMaterial: isActiveTab(DataMappingProps.RAW_MATERIAL, location, true),
  isCommodityDistribution: isActiveTab(
    DataMappingProps.COMMODITY_DISTRIBUTION,
    location,
    true
  ),
  isTransportation: isActiveTab(
    DataMappingProps.TRANSPORTATION,
    location,
    true
  ),
  isFuelAndEnergy: isActiveTab(
    DataMappingProps.FUEL_AND_ENERGY,
    location,
    true
  ),
  isField: isActiveTab(DataMappingProps.FIELD, location, true),
  isOverview: isActiveTab(DataMappingProps.FARMBOX_OVERVIEW, location, true),
  isFeed: isActiveTab(DataMappingProps.FEED_PATH, location, true),
});

export const useTypeGuards = () => ({
  isRawMaterialsData: (data: FormDataTypes): data is FarmboxRawMaterialsData =>
    (data as FarmboxRawMaterialsData).fertilizers?.[0]?.activityLabel !==
    undefined,

  isTransportationData: (data: FormDataTypes): data is TransportationDetails =>
    (data as TransportationDetails)?.fertilizers?.[0]?.name !== undefined,

  isFuelAndEnergyData: (data: FormDataTypes): data is FuelAndEnergyDetails =>
    (data as FuelAndEnergyDetails).commodity?.scope1Emission !== undefined,

  isFieldData: (data: FormDataTypes): data is FieldDetails =>
    (data as FieldDetails).commodity?.harvestYear !== undefined,
});
